import { combineReducers } from 'redux';
import { createResponsiveStateReducer } from 'redux-responsive';
import getApiReducer from '../common/utils/getApiReducer';
import { reducer as form } from 'redux-form';
import { List } from 'immutable';

import { GET_GIFT_SUBSCRIPTION_PRICE, PUSH_TOAST, SHIFT_TOAST, VALIDATE_PROMO_CODE } from './actions';
import styleGuide from '../style-guide/redux/reducers';
import subscription from '../subscription/redux/reducers';

const browser = createResponsiveStateReducer({
  tabletPortrait: 599,
  tabletLandscape: 899,
  desktop: 1199,
});

const toasts = (state = new List(), action) => {
  if (action.type === PUSH_TOAST) {
    return state.push(action.payload);
  }
  if (action.type === SHIFT_TOAST) {
    return state.shift();
  }
  return state;
};

export default combineReducers({
  browser,
  form,
  giftSubscriptionPrice: getApiReducer(GET_GIFT_SUBSCRIPTION_PRICE),
  promoCode: getApiReducer(VALIDATE_PROMO_CODE),
  styleGuide,
  subscription,
  toasts,
});



// WEBPACK FOOTER //
// ./src/redux/reducers.js